module.exports = __webpack_public_path__ + "5e762a7d62721730f157ffc4c0efbd2c.jpg";